export const plans = {
  EDUNEXORA_PROD: [
    {
      id: 'limited',
      name: 'Limited',
      description: 'Perfect for getting started',
      monthlyPrice: 15,
      sixMonthPrice: 12,
      yearlyPrice: 8,
      priceId: {
        monthly: 'pri_01jxfhft7nm3sb9pcrk4erf74v',
        sixMonth: 'pri_01jx5je12qadymrrqkd2xw7ppf',
        yearly: 'pri_01jxfhhqdyafn76s6qmash4tr1',
      },
      dailyTokens: 100,
      monthlyTokens: 300,
      popular: false,
      features: [
        'Up to 2 courses per day',
        '12 learning topics daily',
        '10 quizzes and flashcards',
        'Basic AI chat support',
      ],
      limitations: ['Limited visual learning', 'Basic token allocation'],
    },
    {
      id: 'premium',
      name: 'Premium',
      description: 'Most popular for active learners',
      monthlyPrice: 16,
      sixMonthPrice: 15,
      yearlyPrice: 9,
      priceId: {
        monthly: 'pri_01jx5jjzejqbr0gee2xxbte9ay',
        sixMonth: 'pri_01jxfj30wssr9506m37rmesbr4',
        yearly: 'pri_01jxfj3k7vgy96bs2jgs5tvbv1',
      },
      dailyTokens: 150,
      monthlyTokens: 450,
      popular: true,
      features: [
        'Up to 3 courses per day',
        '18 learning topics daily',
        '15 quizzes and flashcards',
        'Enhanced AI conversations',
      ],
      limitations: [],
    },
    {
      id: 'elite',
      name: 'Elite',
      description: 'For power users and educators',
      monthlyPrice: 19,
      sixMonthPrice: 16,
      yearlyPrice: 12,
      priceId: {
        monthly: 'pri_01jx5jhfc9nh5z57p76t68nxt9',
        sixMonth: 'pri_01jxfhdqthgf9dq1hjfq11mpdd',
        yearly: 'pri_01jxfheqksc8rdw6t9d7trhjm8',
      },
      dailyTokens: 300,
      monthlyTokens: 900,
      popular: false,
      features: [
        'Up to 6 courses per day',
        '37 learning topics daily',
        '30 quizzes and flashcards',
        'Unlimited AI conversations',
        'Custom learning paths',
      ],
      limitations: [],
    },
  ],
  BROGRAMMERS_PROD: [
    {
      id: 'limited',
      name: 'Limited',
      description: 'Perfect for getting started',
      monthlyPrice: 15,
      sixMonthPrice: 12,
      yearlyPrice: 8,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 100,
      monthlyTokens: 300,
      popular: false,
      features: [
        'Up to 2 courses per day',
        '12 learning topics daily',
        '10 quizzes and flashcards',
        'Basic AI chat support',
      ],
      limitations: ['Limited visual learning', 'Basic token allocation'],
    },
    {
      id: 'premium',
      name: 'Premium',
      description: 'Most popular for active learners',
      monthlyPrice: 16,
      sixMonthPrice: 15,
      yearlyPrice: 9,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 150,
      monthlyTokens: 450,
      popular: true,
      features: [
        'Up to 3 courses per day',
        '18 learning topics daily',
        '15 quizzes and flashcards',
        'Enhanced AI conversations',
      ],
      limitations: [],
    },
    {
      id: 'elite',
      name: 'Elite',
      description: 'For power users and educators',
      monthlyPrice: 19,
      sixMonthPrice: 16,
      yearlyPrice: 12,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 300,
      monthlyTokens: 900,
      popular: false,
      features: [
        'Up to 6 courses per day',
        '37 learning topics daily',
        '30 quizzes and flashcards',
        'Unlimited AI conversations',
        'Custom learning paths',
      ],
      limitations: [],
    },
  ],
  BROGRAMMERS_TEST: [
    {
      id: 'limited',
      name: 'Limited Test',
      description: 'Perfect for getting started',
      monthlyPrice: 15,
      sixMonthPrice: 12,
      yearlyPrice: 8,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 100,
      monthlyTokens: 300,
      popular: false,
      features: [
        'Up to 2 courses per day',
        '12 learning topics daily',
        '10 quizzes and flashcards',
        'Basic AI chat support',
      ],
      limitations: ['Limited visual learning', 'Basic token allocation'],
    },
    {
      id: 'premium',
      name: 'Premium Test',
      description: 'Most popular for active learners',
      monthlyPrice: 16,
      sixMonthPrice: 15,
      yearlyPrice: 9,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 150,
      monthlyTokens: 450,
      popular: true,
      features: [
        'Up to 3 courses per day',
        '18 learning topics daily',
        '15 quizzes and flashcards',
        'Enhanced AI conversations',
      ],
      limitations: [],
    },
    {
      id: 'elite',
      name: 'Elite Test',
      description: 'For power users and educators',
      monthlyPrice: 19,
      sixMonthPrice: 16,
      yearlyPrice: 12,
      priceId: {
        monthly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        sixMonth: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
        yearly: 'pri_01jxsb237bekk7kmvcc7c4ge0m',
      },
      dailyTokens: 300,
      monthlyTokens: 900,
      popular: false,
      features: [
        'Up to 6 courses per day',
        '37 learning topics daily',
        '30 quizzes and flashcards',
        'Unlimited AI conversations',
        'Custom learning paths',
      ],
      limitations: [],
    },
  ],
};
